import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>TKS Courier & Cargo International Service</h3>
            <p>Your trusted partner for reliable courier and cargo services in Singapore.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/" onClick={() => scrollToSection('home')}>Home</Link></li>
              <li><Link to="/" onClick={() => scrollToSection('services')}>Services</Link></li>
              <li><Link to="/why-us">Why Us</Link></li>
              <li><Link to="/" onClick={() => scrollToSection('about')}>About Us</Link></li>
              <li><Link to="/" onClick={() => scrollToSection('map')}>Location</Link></li>
              <li><Link to="/booking">Booking</Link></li>
              <li><Link to="/tracking">Tracking</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/testimonials">Testimonials</Link></li>
              <li><Link to="/" onClick={() => scrollToSection('contact')}>Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📞 +65 8151 5199</p>
            <p>📧tksimpextrading@gmail.com</p>
            <p>📍41,CuffRoad,Singapore-209751</p>
          </div>
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="#" aria-label="Facebook">📘 Facebook</a>
              <a href="#" aria-label="Twitter">🐦 Twitter</a>
              <a href="#" aria-label="LinkedIn">💼 LinkedIn</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 TKS Courier & Cargo International Service. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;